import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { AuthService } from '@services'
import { environment } from 'environments/environment'
import { throwError, from } from 'rxjs'
import { catchError, switchMap } from 'rxjs/operators'

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService)

  if (req.url.includes(environment.cms_latam_api.baseUrl)) {
    return from(auth.getTenantActive()).pipe(
      switchMap((userInfo) => {
        let headers = req.headers.set('ApiKey', environment.cms_latam_api.apiKey)

        const access = auth.getToken()
        if (access) {
          headers = headers.set('Authorization', access)
        }

        headers = headers.set('tenantId', userInfo?.id?.toString() || '')

        const cloned = req.clone({ headers })

        return next(cloned).pipe(
          catchError((err: HttpErrorResponse) => {
            if (err.status === 401) {
              auth.logout()
            }
            return throwError(() => err)
          })
        )
      })
    )
  }

  if (req.url.includes(environment.api.baseUrl)) {
    return from(auth.getTenantActive()).pipe(
      switchMap((userInfo) => {
        let headers = req.headers.set('tenantId', userInfo?.id?.toString() || '')

        if (!headers.has('client_id')) {
          headers = headers.set('client_id', environment.api.clientId)
        }

        if (!headers.has('Accept-Language')) {
          headers = headers.set('Accept-Language', 'pt-BR')
        }

        const access = auth.getToken()
        if (access) {
          headers = headers.set('Authorization', access)
        }

        const cloned = req.clone({ headers })

        return next(cloned).pipe(
          catchError((err: HttpErrorResponse) => {
            if (err.status === 401) {
              auth.logout()
            }
            return throwError(() => err)
          })
        )
      })
    )
  }

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        auth.logout()
      }
      return throwError(() => err)
    })
  )
}
